import { setPositionX, setPositionY } from "../helpers";
import { icon_panTool } from "../Resources/drawing-icons";
import { html } from "lit-element";
import { LitElement } from "lit-element";

export class DrawGestureAndMouseEvents extends LitElement {
	get MainTb() {
		return {
			value: "move",
			icon: icon_panTool,
			text: "move"
		};
	}

	Activate() {
		this.canvas.setCursor("grab");
		this.canvas.on({
			"mouse:down": this.__mouseDownHandler,
			"mouse:move": this.__mouseMoveHandler,
			"mouse:up": this.__mouseUpHandler,
			"touch:drag": this.__touchDragHandler,
			"touch:gesture": this.__touchGestureHandler,
		});
		return this;
	}
	
	Deactivate() {
		this.canvas.off({
			"mouse:down": this.__mouseDownHandler,
			"mouse:move": this.__mouseMoveHandler,
			"mouse:up": this.__mouseUpHandler,
			"touch:drag": this.__touchDragHandler,
			"touch:gesture": this.__touchGestureHandler,
		});
	}

	render() {
		return html`
           
            `;
	}

	constructor(canvas, zoomModule) {
		super();
		this.canvas = canvas;
		this.zoomModule = zoomModule;
		this.__mouseDownHandler = this.mouseDownHandler.bind(this);
		this.__mouseMoveHandler = this.mouseMoveHandler.bind(this);
		this.__mouseUpHandler = this.mouseUpHandler.bind(this);
		this.__touchDragHandler = this.touchDragHandler.bind(this);
		this.__touchGestureHandler = this.touchGestureHandler.bind(this);
	}

	touchGestureHandler(opt) {
		const e = opt.e;
		if (e instanceof TouchEvent) {
			// two fingers = zooming
			if (e.touches && e.touches.length === 2) {
				const t1 = e.touches[0], t2 = e.touches[1];
				if (e.type === "touchstart") {
					this.canvas.lastZoom = this.zoomModule.zoom;
					this.canvas.lastTouchDistance = this._getDistanceBewteenPoints(t1, t2);
				} else if (e.type === "touchmove") {
					const newDist = this._getDistanceBewteenPoints(t1, t2);
					const delta = this.canvas.lastTouchDistance - newDist;
					this.zoomModule.zoom = this.canvas.lastZoom - delta / 1000;
					if (this.zoomModule.isMaxZoomReached) this.zoomModule.zoom = this.zoomModule.zoomMax;
					if (this.zoomModule.isMinZoomReached) this.zoomModule.zoom = this.zoomModule.zoomMin;
					this.zoomModule.applyZoom();
				}
			}
		}
	}

	_getDistanceBewteenPoints(t1, t2) {
		return Math.sqrt(
			Math.pow(t2.clientX - t1.clientX, 2) +
            Math.pow(t2.clientY - t1.clientY, 2)
		);
	}

	touchDragHandler(opt) {
		const e = opt.e;
		if (e instanceof TouchEvent) {
			// one finger = changing viewport
			if (e.touches && e.touches.length === 1) {
				const t = e.touches[0];
				if (this.canvas.lastTouchPosX == undefined) this.canvas.lastTouchPosX = t.clientX;
				if (this.canvas.lastTouchPosY == undefined) this.canvas.lastTouchPosY = t.clientY;
				const relativeX = this.canvas.lastTouchPosX - t.clientX;
				const relativeY = this.canvas.lastTouchPosY - t.clientY;
				setPositionX(this.canvas, relativeX);
				setPositionY(this.canvas, relativeY);
				this.canvas.lastTouchPosX = t.clientX;
				this.canvas.lastTouchPosY = t.clientY;
			}
		} else {
			// the drag event with e instance of Object goes the last while dragging
			this.canvas.lastTouchPosX = this.canvas.lastTouchPosY = null;
		}
	}
    
	mouseDownHandler(opt) {
		this.canvas.setCursor("grabbing");
		this.canvas.isDragging = true;
		this.canvas.lastPosX = opt.e.clientX;
		this.canvas.lastPosY = opt.e.clientY;
	}

	mouseMoveHandler(opt) {
		if (!this.canvas.isDragging) return;

		const relativeX = this.canvas.lastPosX - opt.e.clientX;
		const relativeY = this.canvas.lastPosY - opt.e.clientY;
		setPositionX(this.canvas, relativeX);
		setPositionY(this.canvas, relativeY);
		this.canvas.lastPosX = opt.e.clientX;
		this.canvas.lastPosY = opt.e.clientY;
	}

	mouseUpHandler() {
		this.canvas.setCursor("grab");
		this.canvas.isDragging = false;
	}
}

window.customElements.define("inspx-draw-move", DrawGestureAndMouseEvents);
